import React from "react";
import { Tabs } from "antd";
import { PictureOutlined, TeamOutlined, TrophyOutlined, ReadOutlined } from "@ant-design/icons";
import GraphicsOversight from "./graphics/GraphicsOversight";
import BlogWriteOversight from "./blogWrite/BlogWriteOversight";
import BrandWorkload from "./BrandWorkload";
import RenewalRate from "./RenewalRate";

// Single consolidated entry point for every workload/reporting surface —
// Graphics Team oversight, Blog Write Team oversight and Brand Manager/
// Strategist reporting used to be separate sidenav items; now they're tabs
// under one "Workload" nav entry so there's one place to look, not several.
function Workload() {
  return (
    <Tabs
      defaultActiveKey="graphics"
      className="workload-tabs"
      items={[
        {
          key: "graphics",
          label: (
            <span>
              <PictureOutlined /> Graphics Team
            </span>
          ),
          children: <GraphicsOversight />,
        },
        {
          key: "blogWrite",
          label: (
            <span>
              <ReadOutlined /> Blog Write Team
            </span>
          ),
          children: <BlogWriteOversight />,
        },
        {
          key: "brand",
          label: (
            <span>
              <TeamOutlined /> Brand Team
            </span>
          ),
          children: <BrandWorkload />,
        },
        {
          key: "renewal",
          label: (
            <span>
              <TrophyOutlined /> KPI Report
            </span>
          ),
          children: <RenewalRate />,
        },
      ]}
    />
  );
}

export default Workload;
